/**
 * Generates an invoice PDF using @react-pdf/renderer, matching the pattern
 * used for proposal/contract PDFs in downloadDocumentPdf.ts.
 */
import React from 'react'
import { pdf } from '@react-pdf/renderer'
import { InvoiceDocumentPdf, type InvoiceDocumentProps } from '../components/InvoiceDocumentPdf'

export async function buildInvoicePdfBlob(props: InvoiceDocumentProps): Promise<Blob> {
  const instance = pdf(React.createElement(InvoiceDocumentPdf, props) as any)
  return instance.toBlob()
}

export async function downloadInvoicePdf(props: InvoiceDocumentProps, fileName: string): Promise<void> {
  const blob = await buildInvoicePdfBlob(props)
  const url = URL.createObjectURL(blob)
  try {
    const link = document.createElement('a')
    link.href = url
    link.download = `${fileName}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 1000)
  }
}
